import { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Transition } from "react-transition-group";
import SC from "./style";
function CustomAccordion(props) {
  const {
    headerContent,
    children,
    sx = {},
    toggleIconsx = {},
    expandIcon = true,
    defaultExpanded = false,
    onClick = () => {},
  } = props;
  const [expanded, setExpanded] = useState(defaultExpanded);
  const handleChange = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };
  return (
    <>
      {SC.GlobalStyles}
      <SC.Container marginBottom={sx.marginBottom} onClick={onClick}>
        <Accordion expanded={expanded} onChange={handleChange}>
          <AccordionSummary
            sx={sx}
            expandIcon={
              expandIcon ? <ExpandMoreIcon sx={toggleIconsx} /> : null
            }
          >
            {headerContent}
          </AccordionSummary>
          <Transition in={expanded} timeout={200} mountOnEnter unmountOnExit>
            {(state) => (
              <AccordionDetails
                style={{
                  transition: `opacity 0.3s ease-in-out`,
                  opacity: state === "entered" ? 1 : 0,
                }}
              >
                {children}
              </AccordionDetails>
            )}
          </Transition>
        </Accordion>
      </SC.Container>
    </>
  );
}
export default CustomAccordion;
